import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const tabs = [
  { path: '/', icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill', label: '首页' },
  { path: '/agent', icon: 'ri-robot-2-line', activeIcon: 'ri-robot-2-fill', label: '跟单' },
  { path: '/assets', icon: 'ri-wallet-3-line', activeIcon: 'ri-wallet-3-fill', label: '收益' },
  { path: '/profile', icon: 'ri-user-3-line', activeIcon: 'ri-user-3-fill', label: '我的' },
];

export default function TabBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const guestHome = !loading && !user && location.pathname === '/';

  return (
    <nav
      aria-label="底部导航"
      className={`${guestHome ? 'md:hidden ' : ''}fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-100`}
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div
        className="grid grid-cols-4 w-full"
        style={{ height: '56px' }}
      >
        {tabs.map((tab) => {
          const isActive =
            location.pathname === tab.path ||
            (tab.path === '/agent' && location.pathname.startsWith('/agent')) ||
            (tab.path === '/profile' && location.pathname.startsWith('/profile')) ||
            (tab.path === '/assets' && location.pathname.startsWith('/assets'));

          return (
            <button
              key={tab.path}
              aria-current={isActive ? 'page' : undefined}
              onClick={() => navigate(tab.path)}
              className="flex flex-col items-center justify-center gap-0.5 relative"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i
                  className={`${isActive ? tab.activeIcon : tab.icon} text-xl`}
                  style={{ color: isActive ? '#6366F1' : '#94A3B8' }}
                />
              </div>
              <span
                className="font-medium"
                style={{ color: isActive ? '#6366F1' : '#94A3B8', fontSize: '10px' }}
              >
                {tab.label}
              </span>
              {/* Active indicator bar */}
              {isActive && (
                <div
                  className="absolute bottom-1 w-5 h-0.5 rounded-full"
                  style={{ background: '#6366F1' }}
                />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
